export default "__VITE_ASSET__o8o0Tnk6__"